
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import IQueryShortDto = MdbsCore.IQueryShortDto;
import IQueryAnswerDto = MdbsCore.IQueryAnswerDto;
import {queryModule} from "@/store";
import IQueryAcceptDto = MdbsCore.IQueryAcceptDto;
import IQueryRevokeDto = MdbsCore.IQueryRevokeDto;
import IQuerySolveDto = MdbsCore.IQuerySolveDto;
import {deepCopy} from "@/auxillary";
import QueryTypeDefinitionDto = MdbsCore.QueryTypeDefinitionDto;
import QueryAnswerDialog from "@/components/query/dialogs/QueryAnswerDialog.vue";
import IQueryEditDto = MdbsCore.IQueryEditDto;
import DataFieldQueriesCountIcon from "@/components/query/icons/DataFieldQueriesCountIcon.vue";
import IQueryDeferDto = MdbsCore.IQueryDeferDto;
import QueryAnswerMenuItem from "@/components/query/menu/QueryAnswerMenuItem.vue";

@Component({
  name: 'DataFieldQueriesMenu',
  components: {DataFieldQueriesCountIcon, QueryAnswerMenuItem, QueryAnswerDialog},
})
export default class DataFieldQueriesMenu extends Vue {

  @Prop({required: true})
  private queries: Array<IQueryShortDto>;
  @Prop({required: true})
  private queryTypeDefinitions: Array<QueryTypeDefinitionDto>;
  @Prop({required: true})
  private referenceId: string;
  @Prop({required: true})
  private referenceType: string;

  showAnswerQuery = false;
  selectedQuery: IQueryShortDto | null = null;


  queryTypeDefinition(query: IQueryShortDto): QueryTypeDefinitionDto | undefined {
    if (!query)
      return undefined;
    return this.queryTypeDefinitions.find(qf => qf.definitionType == query.queryTypeDefinitionType);
  }

  handleAnswerQuery(query: IQueryShortDto) {
    this.selectedQuery = deepCopy(query);
    this.showAnswerQuery = true;
  }

  async handleEditQuery(queryEdit: IQueryEditDto) {
    await queryModule.editQuery(queryEdit);
    await queryModule.loadQueriesForFields({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleSaveAnswerQuery(queryAnswer: IQueryAnswerDto) {
    await queryModule.answerQuery(queryAnswer);
    await queryModule.loadQueriesForFields({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleRevokeAnswerQuery(queryRevoke: IQueryRevokeDto) {
    await queryModule.revokeQuery(queryRevoke);
    await queryModule.loadQueriesForFields({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleAcceptAnswerQuery(queryAccept: IQueryAcceptDto) {
    await queryModule.acceptQuery(queryAccept);
    await queryModule.loadQueriesForFields({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleSolveAnswerQuery(querySolve: IQuerySolveDto) {
    await queryModule.solveQuery(querySolve);
    await queryModule.loadQueriesForFields({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }

  async handleDeferAnswerQuery(queryDefer: IQueryDeferDto) {
    await queryModule.deferQuery(queryDefer);
    await queryModule.loadQueriesForFields({referenceType: this.referenceType, referenceId: this.referenceId});
    this.showAnswerQuery = false;
  }
}
